module.exports = __webpack_public_path__ + "img/withdraw.c075ff92.png";